__turbopack_context__.v({
  "dot": "yiK8XW_dot",
  "remainedTimeCounterLabel": "yiK8XW_remainedTimeCounterLabel",
  "remainedTimeCounterNumber": "yiK8XW_remainedTimeCounterNumber",
  "remainedTimeCounterNumberWrapper": "yiK8XW_remainedTimeCounterNumberWrapper",
  "remainedTimeCounterWrapper": "yiK8XW_remainedTimeCounterWrapper",
  "remainedTimeTitle": "yiK8XW_remainedTimeTitle",
  "remainedTimeWrapper": "yiK8XW_remainedTimeWrapper",
  "title": "yiK8XW_title",
  "wrapper": "yiK8XW_wrapper",
});
